var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"blog-tags"},[_c('tag-icon',{staticClass:"text-grey",attrs:{"width":"25","fill":"currentColor"}}),_vm._l((_vm.items),function(item,k){return _c('div',{key:k,staticClass:"blog-tag"},[_vm._v(_vm._s(item))])})],2)}
var staticRenderFns = []

export { render, staticRenderFns }